import React from "react";

import './CardSmall.css';

const CardSmall = (props) => {
return (
    <div className="cardsmall-wrapper">
        <img src={props.image} alt={props.card_title} />
        <p className="card-title">{props.card_title}</p>
        <p className="card-text">{props.card_text}</p>
    </div>
)
}

export default CardSmall;